// extracted by mini-css-extract-plugin
module.exports =  {"title":"PkUj394W5BPcBurR3mbD"};